import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { SelectList } from '../shared/SelectList';

interface Props {
    count?: number;
}

const AccountListSkeleton = ({ count = 1 }: Props): JSX.Element => (
    <div className="account-list-skeleton__container">
        <SelectList>
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li className="account-list-skeleton__item" key={`account-list-skeleton-${index}`}>
                    <Skeleton height={19} />
                    <Skeleton className="account-number" width="30%" height={14} />
                </li>
            ))}
        </SelectList>
    </div>
);

export default AccountListSkeleton;
